import React from 'react';
import PropTypes from 'prop-types';

import { ImageTag } from '../../../../../../styled/siteBuilderModules/sharedComponents';

export const ImageList = ({ list }) =>
  list.map(({ image, maxWidth, maxHeight }, index) => (
    <ImageTag
      src={image}
      imgix={false}
      lazy={false}
      style={{ maxWidth, maxHeight }}
      key={index}
    />
  ));

ImageList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      maxWidth: PropTypes.number,
      maxHeight: PropTypes.number,
    }),
  ),
};
